import { ToggleSwitch, Tooltip } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../../../CustomIcons';

import './styles/index.css';

function NotificationPreferencesTile({ ...props }) {
  const { isNotificationPreferencesEnabled, toggleHandler, tileData, toggleOptions } = props;
  return (
    <div className="notification-preferences-options-wrapper">
      <div className="content">
        <div className="options-toggle-switch">
          <ToggleSwitch
            onChange={e => toggleHandler(e, tileData.id, tileData.name)}
            small
            checked={isNotificationPreferencesEnabled && tileData.isEntityToggled}
            id={tileData.id}
          />
        </div>
        <div className="options-toggle-switch-label epsilon">
          <h5>{toggleOptions.value}</h5>
        </div>
        {toggleOptions.infoIconMessage && (
          <div className="options-toggle-switch-info">
            <CustomIcon
              data-tooltip-id="options-toggle-tooltip"
              data-tooltip-content={toggleOptions.infoIconMessage}
              type="info"
              size="24"
              className="info-icon"
            />
            <Tooltip identifier="options-toggle-tooltip" />
          </div>
        )}
        <div />
      </div>
    </div>
  );
}

NotificationPreferencesTile.defaultProps = {
  tileData: {
    id: '',
    name: '',
    isEntityToggled: false
  },
  toggleOptions: {
    value: '',
    infoIconMessage: ''
  }
};

NotificationPreferencesTile.propTypes = {
  toggleOptions: PropTypes.shape({
    value: PropTypes.string,
    infoIconMessage: PropTypes.string
  }),
  isNotificationPreferencesEnabled: PropTypes.bool.isRequired,
  tileData: PropTypes.shape({
    id: PropTypes.string,
    isEntityToggled: PropTypes.bool,
    name: PropTypes.string
  }),
  toggleHandler: PropTypes.func.isRequired
};

export default NotificationPreferencesTile;
